import React, { useState } from 'react';
import Profile from './Dashboard/Profile';
import Setting from './Dashboard/Settings';
import Sidebar from './Dashboard/Sidebar';
import StartAssessment from './StartAssessment';

const AssesmentDash = () => {
    const [activeComponent, setActiveComponent] = useState('Assessment');


    const renderComponent = () => {
        switch (activeComponent) {
            case 'Profile':
                return <Profile />;
            case 'Assessment':
                return <StartAssessment />;
            // case 'Setting':
            //     return <Setting />;
            default:
                return <StartAssessment />;
        }
    };

    return (
        <div data-aos="fade-up" className="navFixMargin flex flex-col md:flex-row">
            <Sidebar activeComponent={activeComponent} setActiveComponent={setActiveComponent} />
            <main data-aos="fade-up" className="w-full md:w-3/4 p-6">
                {renderComponent()}
            </main>
        </div>
    );
};

export default AssesmentDash;
